import React from 'react'
import { Flex, FlexProps } from '@chakra-ui/react'
import { motion, MotionProps } from 'framer-motion'

const CustomeFlex = React.forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  return <Flex ref={ref} {...props} />
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MotionFlex: any = motion(CustomeFlex as any)

export default MotionFlex
